import React, { useEffect, useState } from "react";
import BookingApi from "../../API/Apis/BookingApi";
import { IndividualUserForms } from "../../components/UI/AllWebCheckInForms/IndividualUserForms";
import { BookingGetters } from "../../store/onlineBooking/getters";
import NotAuthorisedPage from "../notAuthorisedPage";

export function CustomerDetails() {
  const appSettings = BookingGetters.getAppSettings();
  const [showReserve, setShowReserve] = useState<boolean>(
    !!appSettings?.reservedArea
  );
  return (
    <>
      {showReserve ? (
        <div>
          {" "}
          <IndividualUserForms />
        </div>
      ) : (
        <NotAuthorisedPage />
      )}
    </>
  );
}
